// extracted by mini-css-extract-plugin
module.exports = {"itemList":"items__itemList","item":"items__item","itemLink":"items__itemLink","itemImg":"items__itemImg","itemText":"items__itemText"};